export class SitePageChartDataModel {
    averageScoreAccumulatorId: number;
    averageScoreAccumulatorName: string;
    averageScoreAccumulatorAlias: string;
    reviewAgentId: number;
    reviewAgentName: string;
    reviewAgentlias: string;
    data: any;
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/SitePageChartDataModel.ts